<template>
    <v-dialog
    v-model="dialog"
    width="500"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
            v-bind="attrs"
            v-on="on"
            rounded
            block
            >
            {{ ad.button }}
            </v-btn>
        </template>

        <v-card>
            <v-card-title class="text-h5">
                Liity Stake.com-sivustolle ja saat ilmaista käteistä!
            </v-card-title>

            <v-card-text>
                <p class="text-h4">Alla olevan linkin kautta saat seuraavat edut</p>
                <ul>
                    <li><b>Jopa 22€ käteistä (ilman kierrätystä)</b></li>
                    <li>Pääsy välttömästi Bronze VIP -tasolle</li>
                    <li>Pääsy Staken VIP-Telegramiin ja tarjouksiin</li>
                    <li>Rakeback-ominaisuus käyttön heti</li>
                </ul>

                <br>
                <p class="text-h5">Toimi näin:</p>

                <ol>
                    <li>Luo käyttäjätili tämän linkin kautta: <a href="https://stake.com/?c=kanakori" target="_blank">stake.com</a></li>
                    <li>Lähetä Stake-käyttäjänimesi tämän <a href="https://forms.office.com/r/Vmjw29diTJ" target="_blank">lomakkeen</a> kautta</li>
                    <li>Saat 24 tunnin sisällä Stake-tilillesi 7€ käteistä!</li>
                </ol>

                <br>
                <p class="text-h5">Lisätarjous:</p>
                <ol>
                    <li>Jos talletat vähintään 100€, saat 15€ lisää käteistä</li>
                    <li>Lähetä Stake-käyttäjänimesi tämän <a href="https://forms.office.com/r/Vmjw29diTJ" target="_blank">lomakkeen</a> kautta</li>
                </ol>

                <br>
                <p>Tarjouksen raha on käteistä, johon ei liity minkäänlaisia kierrätysvaatimuksia tai vastaavaa. Tarjous vain uusille käyttäjille jotka liittyvät ohessa olevan linkin kautta. Tarjous voimassa rajoitetun ajan. Vain +18. peluuri.fi.</p>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="nwhite"
                text
                @click="dialog = false"
            >
                Sulje
            </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        ad: {
            type: Object,
            required: true
        }
    },
  data () {
    return {
      dialog: false,
    }
  },
}
</script>